import { useRef } from 'react';
import {
    IconButton,
    Icons,
    SelectShell,
    Tooltip,
} from '@hm-group/bads-react';
import type { SelectShellRef } from '@hm-group/bads-react';
import type { MarketRegionConfig } from './SelectionBar';
import styles from './SelectionBar.module.css';

export function MarketRegionSelect({
    channelLabel,
    name,
    testId,
    disabled,
    mainMarketName,
    markets,
    onEyeClick,
    onLinkClick,
}: Readonly<MarketRegionConfig>) {
    const selectRef = useRef<SelectShellRef>(null);

    return (
        <SelectShell
            ref={selectRef}
            disabled={disabled}
            size="normal"
            label={channelLabel}
            labelSize="bold"
            placeholder={mainMarketName}
            searchable={false}
            name={name}
            testId={testId}
        >
            {markets.map((market) => (
                <div key={market.value} className={styles.regionRow}>
                    <IconButton
                        disabled={market.isMainMarket}
                        onClick={() => onEyeClick(market)}
                    >
                        {market.visible ? (
                            <Icons.Eye style={{ width: '18px', height: '18px' }} />
                        ) : (
                            <Icons.EyeInvisible style={{ width: '18px', height: '18px' }} />
                        )}
                    </IconButton>
                    <span
                        className={market.visible ? styles.regionLabel : `${styles.regionLabel} ${styles.regionLabelDisabled}`}
                    >
                        {market.label}
                    </span>
                    <Tooltip
                        content={market.unlinked ? 'Connect to main market' : 'Disconnect from main market'}
                        position="bottom"
                        disabled={market.isMainMarket}
                    >
                        <IconButton
                            disabled={market.isMainMarket}
                            onClick={() => onLinkClick(market)}
                        >
                            {market.unlinked ? (
                                <Icons.LinkOff style={{ width: '18px', height: '18px' }} />
                            ) : (
                                <Icons.Link style={{ width: '18px', height: '18px' }} />
                            )}
                        </IconButton>
                    </Tooltip>
                </div>
            ))}
        </SelectShell>
    );
}
